class AddToCart extends HTMLElement {
  constructor() {
    super();

    this.button = this.closest("button");
    this.form = this.button?.form;

    if (!this.form) return;

    this.onSubmit = (e) => {
      e.preventDefault();

      // const propertyInputs = this.form.querySelectorAll('[name^="properties"]');

      // const properties = Object.fromEntries(
      //   [...propertyInputs].map((input) => {
      //     const key = input.name.match(/\[(?<key>.+)\]/).groups.key;
      //     const value = input.value;
      //     return [key, value];
      //   })
      // );

      // const data = {
      //   id: parseInt(this.form.id.value, 10),
      //   quantity: parseInt(this.form.quantity?.value || 1, 10),
      //   properties,
      // };

      // if (this.form.selling_plan) {
      //   data.selling_plan = this.form.selling_plan.value;
      // }

      const formData = new FormData(this.form);

      const data = {};

      // Add each name/value pair to the object
      for (const [name, value] of formData) {
        data[name] = value;
      }

      if (!("quantity" in data)) {
        data.quantity = 1;
      }

      // // Return the JSON string
      // return JSON.stringify(pairs);

      window.addToCart(data, {
        onAfterAdd: () => {
          document.dispatchEvent(new CustomEvent("mini-cart:open"));
        },
      });
    };

    this.form.addEventListener("submit", this.onSubmit);
  }

  disconnectedCallback() {
    this.form?.removeEventListener("submit", this.onSubmit);
  }
}

if (!customElements.get("add-to-cart")) {
  customElements.define("add-to-cart", AddToCart);
}
